export default __webpack_public_path__ + "static/media/brown-avatar.3df1f0ca.svg";